import { Form, Formik, FormikHelpers, useFormikContext } from 'formik';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Button, Col, Dropdown, Modal, Row } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import { AppContext } from '../../../appContext/AppContext';
import { KEY_LOCALSTORAGE } from '../../../auth/core/_consts';
import AutocompleteV2 from '../../../component/AutocompleteObjectV2';
import { ConfirmDialog } from '../../../component/ConfirmDialog';
import CustomIconButton from '../../../component/custom-icon-button/CustomIconButton';
import CustomTabMenu from '../../../component/CustomTabMenu';
import DatePickerCustom from '../../../component/date-picker/DatePickerCustom';
import { IconBack, IconButtonSave, IconMenu } from '../../../component/IconSvg';
import LabelRequired from '../../../component/LabelRequired';
import SelectTree from '../../../component/SelectTree';
import { TableCustomHeader } from '../../../component/table/components/TableCustomHeader';
import { TableCustom } from '../../../component/table/table-custom/TableCustom';
import TextField from '../../../component/TextField';
import ICD10 from '../../../phan-he-kham-benh/components/ICD10';
import InfoPatientRight from '../../../phan-he-kham-benh/components/InfoPatientRight';
import ProvisonalDiagnosis from '../../../phan-he-kham-benh/components/ProvisonalDiagnosis';
import { TreeChiDinhDichVu } from '../../../phan-he-kham-benh/constants/KhamBenh';
import { CHI_PHI_THUOC_FIELDS, CHI_PHI_THUOC_TYPE } from '../../../phan-he-kham-benh/constants/Thuoc';
import { getPriceByObjectType } from '../../../phan-he-kham-benh/modals/modal-ke-thuoc/utils';
import { getDrugDetailById, getTermByClassIds, getWarehouse } from '../../../phan-he-kham-benh/services/ThuocService';
import { handleConvertBenhNhanInfo } from '../../../phan-he-noi-tru/common/functionCommon';
import { usePhanHeNoiTruContext } from '../../../phan-he-noi-tru/PhanHeNoiTruContext';
import { IDanhSachDanhMuc } from '../../../phan-he-tiep-nhan-thanh-toan/models/TiepDonModel';
import PaymentInfor from '../../../phan-he-vien-phi/components/PaymentInfor';
import { getFormFieldConfig, getPaymentDetail } from '../../../phan-he-vien-phi/services/PhanHeVienPhiServices';
import { APP_TIMESTAMP_FORMAT, CODE, DS_NOI_TRU_TIEP_DON, KEY_DS_DANH_MUC_TIEP_DON, ORDER_TYPE_ID, REQUEST_FROM, REQUEST_TYPE, RESPONSE_MESSAGE, TERM_CLASS_IDS, TYPE } from '../../../utils/Constant';
import { formatDateDTO, formatDateTime, formatMoney } from '../../../utils/FormatUtils';
import { getIndexedDBItem } from '../../../utils/IndexedDB';
import { localStorageItem } from '../../../utils/LocalStorage';
import { getWarehouseProcess } from '../../../utils/ServicesUtils';
import { usePhanHeDieuTriNoiTruContext } from '../../PhanHeDieuTriContext';
import { getDsPhieuDieuTri } from '../../services/BenhAnServices';
import { fetchKeThuoc, updateKeThuoc } from '../../services/DieuTriServices';
import PhieuDieuTriDialog from '../benh-an/components/content/components/thong-tin-benh-an/components/phieu-dieu-tri/components/PhieuDieuTriDialog';
import { MauSelectedColumns } from './Column';
import HeaderMau from './components/HeaderMau';
import SelectTableButton from './components/select-mau-button';

type Props = {
	phieuDieuTri?: any
	handleClose?: () => void
	itemEdit?: any;
	callbackFunc?: () => void;
};

const ChiDinhMau = ({ phieuDieuTri, handleClose, itemEdit, callbackFunc }: Props) => {
	const intl = useIntl();
	const [openPhieuDieuTriDialog, setOpenPhieuDieuTriDialog] = useState<boolean>(false);
	const { benhNhanDieuTri } = usePhanHeDieuTriNoiTruContext();
	const { statusChangedEventFunc } = usePhanHeNoiTruContext();
	const { setIsLoading } = useContext(AppContext);
	const [listComorbidity, setListComorbidity] = useState<any[]>([]);
	const [tableData, setTableData] = useState<any[]>([]);
	const [khoMauSelected, setKhoMauSelected] = useState<any>();
	const [openConfirmDelete, setOpenConfirmDelete] = useState<boolean>(false);
	const formikRef = useRef<any>(null);
	const userInfo = localStorageItem.get(KEY_LOCALSTORAGE.CURRENT_USER);
	const [paymentItem, setPaymentItem] = useState<any>([]);
	const [dsKhoMau, setDsKhoMau] = useState<any>([]);
	const [listICD10, setListICD10] = useState<any[]>([]);
	const [shouldOpenModalSelectICD10, setShouldOpenModalSelectICD10] = useState<boolean>(false);
	const [loaiDoiTuong, setLoaiDoiTuong] = useState<any[]>([]);
	const [thongTinChiPhi, setThongTinChiPhi] = useState<any>({
		tongChiPhi: 0,
		bhyt: 0,
		benhNhan: 0,
		tamUng: 0,
		daThu: 0,
		mienGiam: 0,
		conDu: 0,
	});

	const initialValues = {
		doctorOrderDay: formatDateDTO(new Date()),
		phieuDieuTri: phieuDieuTri,
		provisionalDiagnosis: benhNhanDieuTri?.icd10ProvisionalDiagnosisCode,
		provisionalDiagnosisName: benhNhanDieuTri?.icd10ProvisionalDiagnosisName,
		formThongTinMau: {
			totalQuantity: null,
			iventory: 0
		},
	};

	const userMetaData = localStorageItem.get(KEY_LOCALSTORAGE.USER_METADATA);

	const validationSchema = Yup.object().shape({
		formThongTinMau: Yup.object().shape({
			totalQuantity: Yup.number().nullable().required(intl.formatMessage({ id: 'VALIDATION.REQUIRE' }))
				.min(1, intl.formatMessage({ id: 'VALIDATION.REQUIRE' }))
				.when('iventory', (iventory, schema) => {
					return schema.max(
						iventory ?? 0,
						'Số lượng thuốc kê đơn không lớn hơn số lượng thuốc khả dụng'
					);
				}),
		})
	});

	const tongTienDonThuoc = tableData.reduce((acc: number, row: any) => {
		return acc + (row.thanhTien || 0);
	}, 0);
	const tongTienConDu = Math.abs(thongTinChiPhi.tamUng + thongTinChiPhi.daThu - (thongTinChiPhi.benhNhan + tongTienDonThuoc));

	const dsTab = [
		{
			eventKey: '0',
			title: 'Danh sách máu và chế phẩm máu',
			component: <DsMauVaChePhamMau
				setOpenConfirmDelete={setOpenConfirmDelete}
				tableData={tableData}
				khoMauSelected={khoMauSelected}
				setKhoMauSelected={setKhoMauSelected}
				setTableData={setTableData}
				objectTypes={loaiDoiTuong}
			/>,
		},
		{
			eventKey: '1',
			title: 'Phiếu chỉ định',
			component: <span></span>,
		},
	];

	const getDanhMuc = async () => {
		const danhMuc: IDanhSachDanhMuc = await getIndexedDBItem(KEY_DS_DANH_MUC_TIEP_DON);
		setListICD10(danhMuc.listICD10);
		setLoaiDoiTuong(danhMuc.listDoiTuong);
	};
	
	const handleUpdateDsMau = async (values: any, formHelpers: FormikHelpers<any>) => {
		if (!values?.formThongTinMau?.id && !values?.formThongTinMau?.medicalItemId) {
			toast.warning('Chưa chọn máu');
			return;
		}
		
		const { formThongTinMau } = values ?? {};
		const donGia = getPriceByObjectType(
			formThongTinMau,
			formThongTinMau?.objectTypeCode ?? benhNhanDieuTri?.visitObjectTypeCode
		);
		const thanhTien = donGia * parseInt(formThongTinMau?.totalQuantity);
		const objectType = {
			objectTypeId: formThongTinMau?.objectTypeId ?? benhNhanDieuTri?.visitObjectTypeId,
			objectTypeCode: formThongTinMau?.objectTypeCode ?? benhNhanDieuTri?.visitObjectTypeCode,
			objectTypeName: formThongTinMau?.objectTypeName ?? benhNhanDieuTri?.visitObjectTypeName,
		};
		
		let listTemp = [...tableData];
		let medicalItemId = values?.formThongTinMau?.id;
		if (typeof values?.formThongTinMau?.rowIndex === TYPE.NUMBER) {
			listTemp[values?.formThongTinMau?.rowIndex] = { 
				...values?.formThongTinMau,
				...objectType,
				donGia,
				thanhTien
			};
		} else {
			delete values?.formThongTinMau?.id;
			listTemp.push({
				...values?.formThongTinMau,
				...objectType,
				medicalItemId,
				donGia,
				thanhTien,
			});
		}
		setTableData(listTemp);
		formHelpers.setFieldValue('formThongTinMau', {});
		formHelpers.setErrors({});
		formHelpers.setTouched({});
	};

	const handleDelteMau = async () => {
		let listTemp = [...tableData];
		listTemp = listTemp.filter((_, index) => index !== formikRef.current?.values?.formThongTinMau?.index);
		setTableData(listTemp);
		setOpenConfirmDelete(false);
		formikRef.current.setFieldValue('formThongTinMau', {});
	};

	const handleSubmitForm = async () => {
		try {
			const hasDrugData = tableData.length;
			const formValues = formikRef.current?.values;

			if (!formValues?.treatmentSheet) {
				toast.warn('Chưa chọn phiếu điều trị');
				return;
			}

			if (!formValues?.provisionalDiagnosisName && !formValues?.diagnosisNonCoded) {
				toast.warn('Chưa nhập thông tin chẩn đoán!');
				return;
			}

			if (!hasDrugData) {
				toast.warn('Hiện tại chưa có thuốc được kê cho đơn này');
				return;
			}

			setIsLoading(true);
			const listMau: any[] = [];
			const loaiDoiTuongKham = loaiDoiTuong?.find(
				record => record.code === benhNhanDieuTri?.visitObjectTypeCode
			);

			tableData.forEach((row: any) => {
				listMau.push({
					...row,
					visitId: row.visitId ?? benhNhanDieuTri?.visitId,
					medicalItemCode: row.code,
					dosageForm: row.dosage,
					visitObjectTypeId: loaiDoiTuongKham.id,
					visitObjectTypeCode: loaiDoiTuongKham.code,
					visitObjectTypeName: loaiDoiTuongKham.name,
					orderTypeId: parseInt(ORDER_TYPE_ID.MAU),
					patientId: benhNhanDieuTri?.patientId,
					orderId: row.orderId,
					svcFee: row.servicePrice, 
					svcFeeIns: row.bhytPrice, 
					svcFeeHospital: row.hospitalPrice,
				});
			});

			const donThuocRequest: any = {
				id: formValues?.id,
				encounterId: formValues?.encounterId,
				treatmentSheetId: formValues?.treatmentSheet?.id ?? phieuDieuTri?.id,
				doctorOrderDay: formValues?.doctorOrderDay,
				note: formValues?.ghiChu,
				warehouseName: khoMauSelected?.name,
				warehouseId: khoMauSelected?.id,
				doctorAdvice: formValues?.loiDanBacSi,
				usageTime: formValues?.dotDung,
				reExaminationDate: formValues?.ngayTaiKham
					? new Date(formValues.ngayTaiKham).toISOString()
					: null,
				automaticPrescriptionDate: formValues?.ngayKeTuDong,
				designatedDate: formatDateTime(new Date(), APP_TIMESTAMP_FORMAT),
				patientId: benhNhanDieuTri?.patientId,
				visitId: benhNhanDieuTri?.visitId,
				treatmentDoctorUser: userInfo.sub,
				treatmentDoctorName: userInfo.name,
				designatedPerson: userInfo.name,
				designatedPlace: userInfo?.departments?.[0]?.name,
				orderTypeId: parseInt(ORDER_TYPE_ID.MAU),
				comorbidity: formValues?.comorbidity,
				provisionalDiagnosis: formValues?.provisionalDiagnosis,
				provisionalDiagnosisName: formValues?.provisionalDiagnosisName,
				diagnosisNonCoded: formValues?.diagnosisNonCoded,
				lstMedicalItemOrder: listMau,
				autoPrescriptionDates: formValues?.autoPrescriptionDates?.split(",") ?? [],
				warehouseType: khoMauSelected?.warehouseType,
				formCode: REQUEST_FROM.DIEU_TRI,
				medicalItemTypeCode: REQUEST_TYPE.MAU,
				visitObjectTypeCode: benhNhanDieuTri?.visitObjectTypeCode,
				pid: userMetaData?.personId,
			};

			const { data } = itemEdit ? await updateKeThuoc(donThuocRequest) : await fetchKeThuoc(donThuocRequest);
			if (CODE.SUCCESS === data?.code) {
				toast.success(RESPONSE_MESSAGE.ADD.SUCCESS);
				statusChangedEventFunc();
				handleClose?.();
				callbackFunc?.();
			} else {
				toast.error(data?.[0]?.errorMessage ?? RESPONSE_MESSAGE.ERROR);
			}
		} catch (error) {
			console.error(error);
			toast.error(RESPONSE_MESSAGE.ERROR);
		} finally {
			setIsLoading(false);
		}
	};

	const handleGetThongTinChiPhi = async () => {
		try {
			const { data } = await getPaymentDetail(benhNhanDieuTri?.visitId);
			if (CODE.SUCCESS === data?.code) {
				setThongTinChiPhi({
					tongChiPhi: data?.data?.ttTong,
					bhyt: data?.data?.ttBhyt,
					benhNhan: data?.data?.ttNguoiBenh,
					tamUng: data?.data?.ttTamUng,
					daThu: data?.data?.ttDaThu,
					mienGiam: data?.data?.ttDiscountInv,
					conDu: data?.data?.ttConNo,
				});
			}
		} catch (error) {
			console.error(error);
			toast.error('Xảy ra lỗi khi lấy thống tin chi phi, vui lòng thử lại!');
		}
	}

	const getChiPhiThuocValue = (field: CHI_PHI_THUOC_TYPE) => {
		const MAP_FIELD_VALUE = {
			[CHI_PHI_THUOC_FIELDS.TIEN_DON]: tongTienDonThuoc,
			[CHI_PHI_THUOC_FIELDS.TONG_CHI_PHI]: thongTinChiPhi.tongChiPhi + tongTienDonThuoc,
			[CHI_PHI_THUOC_FIELDS.BHYT]: thongTinChiPhi.bhyt,
			[CHI_PHI_THUOC_FIELDS.NGUON_KHAC]: 0,
			[CHI_PHI_THUOC_FIELDS.BENH_NHAN]:
				thongTinChiPhi.benhNhan + tongTienDonThuoc - thongTinChiPhi.bhyt,
			[CHI_PHI_THUOC_FIELDS.TAM_UNG]: thongTinChiPhi.tamUng,
			[CHI_PHI_THUOC_FIELDS.DA_THU]: thongTinChiPhi.daThu,
			[CHI_PHI_THUOC_FIELDS.MIEN_GIAM]: thongTinChiPhi.mienGiam,
			[CHI_PHI_THUOC_FIELDS.CON_DU]:
				thongTinChiPhi.tamUng +
				thongTinChiPhi.daThu -
				(thongTinChiPhi.benhNhan + tongTienDonThuoc),
		};

		return formatMoney(MAP_FIELD_VALUE[field] || 0);
	};

	const handleSetPaymentInfor = async () => {
		const FORM_FIELD_CONFIG = [
			{
				code: "TONG_CHI_PHI",
				name: "Tổng chi phí",
				value: (thongTinChiPhi.tongChiPhi + tongTienDonThuoc) || 0,
				type: "price",
				color: "text-danger"
			},
			{
				code: "BHYT",
				name: "BHYT",
				value: thongTinChiPhi?.bhyt || 0,
				type: "price",
			},
			{
				code: "NGUON_KHAC",
				name: "Nguồn khác",
				value: 0,
				type: "price",
			},
			{
				code: "BENH_NHAN",
				name: "Bệnh nhân",
				value: (thongTinChiPhi.benhNhan + tongTienDonThuoc - thongTinChiPhi.bhyt) || 0,
				type: "price",
			},
			{
				code: "TAM_UNG",
				name: "Tạm ứng",
				value: thongTinChiPhi?.tamUng || 0,
				type: "price",
			},
			{
				code: "DA_THU",
				name: "Đã thu",
				value: thongTinChiPhi?.daThu || 0,
				type: "price",
			},
			{
				code: "MIEN_GIAM",
				name: "Miễn giảm",
				value: thongTinChiPhi?.mienGiam || 0,
				type: "price",
			},
			{
				code: "CON_NO",
				name: Number(getChiPhiThuocValue('CON_DU')) > 0 ? "Còn dư" : "Còn nợ",
				value: Number(getChiPhiThuocValue('CON_DU')) > 0 ? Number(getChiPhiThuocValue('CON_DU')) : Math.abs(tongTienConDu || 0),
				type: "price",
			},
		]
		try {
			let { data: { data } } = await getFormFieldConfig("FORM_INFO_PAYMENT_ASSIGN");
			const jsonObject = JSON.parse(data[0]?.valueText);

			let newArr: any[] = [];
			jsonObject.forEach((item: any) => {
				let obj = FORM_FIELD_CONFIG.find((obj: any) => obj?.code === item);

				newArr.push(obj);
			})

			setPaymentItem(newArr);
		} catch (err) {
			console.error(err);
		}
	};

	const getDetailKhoThuocSelected = (id: string) => {
		if (!dsKhoMau.length || !id) return;
		return dsKhoMau.find((record: any) => record.id === parseInt(id));
	};

	const handleGetKhoMau = async () => {
		try {
			let formCode = REQUEST_FROM.DIEU_TRI;
			let medicalItemTypeCode = REQUEST_TYPE.MAU;
			const resWarehouseProcess = await getWarehouseProcess({
				formCode,
				medicalItemTypeCode,
				visitObjectTypeCode: benhNhanDieuTri?.visitObjectTypeCode
			});
			if (resWarehouseProcess?.data) {
				const { data } = await getWarehouse({
					warehousePrescriptions: resWarehouseProcess?.data,
				})
				setDsKhoMau(data?.content ?? []);
			} else {
				toast.error('Không tìm thấy cấu hình luồng kho');
				setDsKhoMau([]);
			}
			
		} catch (error) {
			console.error(error);
		}
	};

	const getDetailVatTu = async (value: any) => {
		if (typeof value?.rowIndex !== TYPE.NUMBER) return;

		try {
			setIsLoading(true);
			const response = await getDrugDetailById((value.medicalItemId), {
				warehouseId: khoMauSelected.id,
				consignment: value.consignment,
				serialNumber: value.serialNumber,
			});

			formikRef.current?.setFieldValue("formThongTinMau", {
				...value,
				iventory: response?.data?.iventory,
			});
		} catch (error) {
			console.error(error);
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		getDetailVatTu(formikRef.current?.values?.formThongTinMau);
	}, [formikRef.current?.values?.formThongTinMau?.medicalItemId]);

	useEffect(() => {
		if (itemEdit) {
			formikRef.current?.setValues(itemEdit);
			setTableData(itemEdit?.lstMedicalItemOrderRes?.map((item: any) => ({
				...item,
				servicePrice: item?.svcFee,
				hospitalPrice: item?.svcFeeHospital,
				bhytPrice: item?.svcFeeIns,
				donGia: item?.unitPrice,
				thanhTien: item?.intoMoney
			})) || []);
		}
	}, [itemEdit]);

	useEffect(() => {
		getDanhMuc();
		handleGetKhoMau();
		handleGetThongTinChiPhi();
	}, []);

	useEffect(() => {
		if (dsKhoMau.length && itemEdit?.id) {
			setKhoMauSelected(getDetailKhoThuocSelected(itemEdit?.warehouseId));
		}
	}, [dsKhoMau.length, itemEdit?.id]);

	useEffect(() => {
		handleSetPaymentInfor();
	}, [tongTienDonThuoc, thongTinChiPhi]);

	useEffect(() => {
		if (phieuDieuTri) {
			formikRef.current?.setFieldValue('treatmentSheet', phieuDieuTri);
		}
	}, [phieuDieuTri]);

	return (
		<Modal
			className="page-full"
			fullscreen
			dialogClassName="h-modal"
			show={true}
			animation={false}
			backdropClassName="spaces top-50"
		>
			<Formik<any>
				initialValues={initialValues}
				validationSchema={validationSchema}
				validateOnChange={true}
				onSubmit={handleUpdateDsMau}
				innerRef={formikRef}
			>
				{({
					setFieldValue,
					values,
					setValues,
					errors,
					touched,
				}) => (
					<Form
						id="form-thuoc"
						className="spaces h-calc-vh-50"
					// onKeyDown={handleKeyPress}
					>
						<div className="h-100">
							<Modal.Header className="py-3 header-modal">
								<HeaderMau
									onClose={handleClose}
									tableData={tableData}
									setTableData={setTableData}
									khoMauSelected={khoMauSelected}
									setKhoMauSelected={setKhoMauSelected}
								/>
							</Modal.Header>
							<Modal.Body className="py-6 px-0 spaces overflow-hidden spaces h-calc-vh-90">
								<div className="d-flex flex-column h-100">
									<div className="spaces radius-2 p-10 border-top bg-white">
										<div className="d-flex flex-wrap">
											<div className="spaces W-235 mb-4">
												<DatePickerCustom
													label="Ngày y lệnh"
													name="doctorOrderDay"
													labelClassName="spaces ms-0 min-w-115"
													value={values.doctorOrderDay}
													setDateValue={date => {
														setFieldValue('doctorOrderDay', date);
													}}
													mode="date-time"
													errors={errors?.doctorOrderDay}
													touched={touched?.doctorOrderDay}
													disabled
												/>
											</div>
											<div className="spaces d-flex position-relative align-items-start">
												<Button
													className="bg-white spaces W-90 py-0 pl-10 mb-3"
													onClick={() => setShouldOpenModalSelectICD10(true)}
												>
													<u className="fw-bold text-pri fs-13px">
														Chọn bệnh
													</u>
												</Button>
												<LabelRequired
													label="Chẩn đoán"
													isRequired
													className="min-w-90px"
												/>
											</div>
											<Row className="flex-grow-1 position-relative">
												<ProvisonalDiagnosis
													encounterDiagnosisValues={values}
													encounterDiagnosisErrors={errors}
													encounterDiagnosisTouched={touched}
													listComorbidity={listComorbidity}
													setListComorbidity={setListComorbidity}
													onChange={(data: any) =>
														setValues({
															...values,
															...data,
														})
													}
													handleChangeEncounterDiagnosis={setFieldValue}
												/>
											</Row>
										</div>
										<div className="d-flex align-items-center spaces mt-2">
											<div className="d-flex align-items-center me-4">
												<LabelRequired
													className="spaces min-w-100px me-2"
													label="Kho máu"
												/>
												<div className="spaces W-200">
													<AutocompleteV2
														options={dsKhoMau}
														name="khoMau"
														value={khoMauSelected}
														onChange={selectedOption => {
															setKhoMauSelected(selectedOption);
														}}
													/>
												</div>
											</div>
											<LabelRequired
												className="spaces min-w-100px me-2"
												label="Phiếu điều trị"
											/>
											<div className="spaces W-200">
												<AutocompleteV2
													options={[]}
													searchFunction={getDsPhieuDieuTri}
													searchObject={{
														patientId: benhNhanDieuTri?.patientId,
														visitId: benhNhanDieuTri?.visitId,
														medicalRecordCode: benhNhanDieuTri?.medicalRecordCode,
													}}
													getOptionLabel={option => formatDateTime(option?.prescriptionDate) as string}
													value={values?.treatmentSheet || phieuDieuTri}
													name="treatmentSheet"
													onChange={selectedOption => setValues({
														...values,
														treatmentSheet: selectedOption,
														doctorOrderDay: formatDateDTO(selectedOption?.prescriptionDate)
													})}
												/>
											</div>
											<Button
												variant='link'
												className='link-info text-decoration-underline spaces py-0 pl-10'
												onClick={() => setOpenPhieuDieuTriDialog(true)}
											>
												Thêm phiếu điều trị
											</Button>
										</div>
									</div>

									<div className="spaces h-calc-185">
										<CustomTabMenu
											danhsachTabs={dsTab}
											keyDanhSachTabs={DS_NOI_TRU_TIEP_DON}
										/>
									</div>

									<div className="d-flex justify-content-between spaces px-10 mt-6 bg-white border-top pt-4">
										<PaymentInfor
											className="w-100 price-info"
											paymentData={paymentItem}
										/>
										<div className="d-flex align-items-center">
											<Button className="btn-outline min-w-50 spaces mr-10">
												<i className="bi bi-printer" /> In
											</Button>
											<Button className="btn-fill min-w-50"
												onClick={() => handleSubmitForm()}
											>
												<IconButtonSave /> Lưu
											</Button>
										</div>
									</div>
									{openPhieuDieuTriDialog && (
										<PhieuDieuTriDialog
											open={openPhieuDieuTriDialog}
											onClose={() => setOpenPhieuDieuTriDialog(false)}
											callbackFunc={(data: any) => setValues({
												...values,
												treatmentSheet: data,
												doctorOrderDay: formatDateDTO(data?.prescriptionDate)
											})}
										/>
									)}
									{openConfirmDelete && (
										<ConfirmDialog
											className="z-index-1060"
											show={openConfirmDelete}
											title="Thông báo"
											message="Bạn có chắc chắn muốn xóa?"
											yes="Xác nhận"
											close="Đóng"
											onCloseClick={() => {
												setOpenConfirmDelete(false);
											}}
											onYesClick={handleDelteMau}
										/>
									)}
									<ICD10
										shouldOpenModalSelectICD10={shouldOpenModalSelectICD10}
										setShouldOpenModalSelectICD10={setShouldOpenModalSelectICD10}
										listICD10={listICD10}
										listComorbidity={listComorbidity}
										setListComorbidity={setListComorbidity}
										selectionModeICD10="radio"
										data={values}
										onChange={value =>
											setValues({
												...values,
												...value,
											})
										}
									/>
								</div>
							</Modal.Body>
						</div>
					</Form>

				)}
			</Formik>
		</Modal>
	);
};

export default ChiDinhMau;

const DsMauVaChePhamMau: React.FC<any> = (props) => {
	const { setOpenConfirmDelete, tableData, khoMauSelected, setTableData, objectTypes } = props;
	const { values, setFieldValue, errors, touched } = useFormikContext<any>();
	const [codeCollapses, setCodeCollapses] = useState<string[]>([]);
	const [treeData, setTreeData] = useState<any>(TreeChiDinhDichVu);
	const [idSelected, setIdSelected] = useState<string>('');
	const [loaiMauSelected, setLoaiMauSelected] = useState<any>();

	const columnsActions = {
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				title={'Thao tác'}
				className="text-center text-light min-w-80px"
			/>
		),
		id: 'actions',
		Cell: ({ ...props }) => (
			<div className="d-flex justify-content-center">
				<CustomIconButton
					variant="edit"
					onClick={() => {
						const row = props.row?.original;
						const rowIndex = props.row?.index;
						setFieldValue("formThongTinMau", {
							...row,
							rowIndex
						});
					}}
				>
					<i className="bi bi-pencil-square text-navy"></i>
				</CustomIconButton>
				<CustomIconButton
					variant="delete"
					onClick={() => {
						const rowIndex = props.row?.index;
						setFieldValue("formThongTinMau.index", rowIndex);
						setOpenConfirmDelete(true);
					}}
				>
					<i className="bi bi-trash3-fill text-danger"></i>
				</CustomIconButton>
			</div>
		),
	};

	const handleGetDsMau = async () => {
		try {
			const { data } = await getTermByClassIds(TERM_CLASS_IDS.MAU);
			let filter = data?.[0]?.terms?.map((item: any) => ({
				code: item?.code,
				name: item?.name,
				filter: item?.subs
			}));
			let treeList = {
				code: "all",
				name: "Máu",
				icon: <IconMenu />,
				filter: filter,
			};
			setTreeData(treeList);
		} catch (error) {
			console.error(error);
		}
	};

	useEffect(() => {
		handleGetDsMau();
	}, []);

	const onMauSelect = (selectedMau: any) => {
		if (!selectedMau) {
			return;
		}

		const isExistSelectedDrug = tableData.some((row: any) =>
			row?.code === selectedMau?.code && row?.consignment === selectedMau?.consignment
		);

		if (isExistSelectedDrug) {
			toast.warn(`"${selectedMau.name}" đã được kê trong đơn này`);
			return;
		}

		setFieldValue("formThongTinMau", {
			...selectedMau,
			totalQuantity: null
		});
	}

	const updateRowData = (rowIndex: number, updateValue: (rowData: any) => object) => {
		const listTemp = [...tableData];
		const updatedList = listTemp.map((row: any, index) => {
			if (index === rowIndex) {
				return {
					...row,
					...updateValue(row),
				};
			}
			return row;
		});
		setTableData(updatedList);
	};

	return (
		<div className="spaces bg-white px-0 radius-2 mt-6 table-ke-thuoc d-flex">
			<div className="spaces width-20 h-calc-vh-322 bg-white radius-2 d-flex flex-column">
				<SelectTree
					className="w-100 py-2 ps-4 flex-grow-1 border border-top-0 overflow-auto"
					codeCollapses={codeCollapses}
					handleChangeCollapsesCode={setCodeCollapses}
					idSelected={idSelected}
					handleChangeSelectId={setIdSelected}
					getSelectedItem={(data: any) => setLoaiMauSelected(data)}
					selectTree={treeData}
				/>
			</div>
			<div className="d-flex flex-column spaces width-80 bg-light radius-2">
				<div className="d-flex flex-column spaces width-100 bg-light h-100">
					<div className="bg-white spaces px-10">
						<Row className="spaces py-10">
							<Col xs="6" className="d-flex spaces mb-6 position-relative">
								<SelectTableButton
									setMauSelected={value => {
										onMauSelect(value);
									}}
									maKhoMau={khoMauSelected?.id.toString() || ""}
									maLoaiMau={loaiMauSelected?.code || ""}
									label="Tên máu"
									labelClassName="spaces min-w-90"
									containerClassName='w-100'
									inputValue={values?.formThongTinMau?.name}
								/>
							</Col>
							<Col xs="2">
								<TextField
									label="Đơn vị"
									name="unitofMeasureName"
									value={values?.formThongTinMau?.unitofMeasureName ?? ""}
									labelClassName="ms-0 min-w-90px"
									disabled
								/>
							</Col>
							<Col xs="2">
								<TextField
									label="Thể tích"
									name="volume"
									value={values?.formThongTinMau?.volume ?? ""}
									labelClassName="ms-0 min-w-90px"
									disabled
								/>
							</Col>
							<Col xs="2">
								<TextField
									label="Số lượng"
									name="formThongTinMau.totalQuantity"
									value={values?.formThongTinMau?.totalQuantity ?? ""}
									labelClassName="ms-0 min-w-90px"
									onChange={(e: any) => setFieldValue("formThongTinMau.totalQuantity", e.target.value)}
									error={(errors?.formThongTinMau as any)?.totalQuantity}
									touched={(touched?.formThongTinMau as any)?.totalQuantity}
								/>
							</Col>
							<Col xs="6">
								<TextField
									label="HDSD"
									name="usageInstructions"
									value={values?.formThongTinMau?.usageInstructions ?? ""}
									labelClassName="ms-0 min-w-90px"
									onChange={(e: any) => setFieldValue("formThongTinMau.usageInstructions", e.target.value)}
								/>
							</Col>
							<Col xs="2">
								<Button className="btn-fill" type="submit">Xác nhận</Button>
							</Col>
						</Row>
						<div className="h-calc-vh-413 spaces bg-white mb-6">
							<TableCustom<any>
								data={tableData}
								columns={MauSelectedColumns}
								columnsActions={columnsActions}
								tableOptions={{
									updateRowData,
									objectTypes,
									getPriceByObjectType,
								}}
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
